import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./errorBoundary";
import { Provider } from "react-redux";
import store from "./app/store";
import { KindeWrapper } from "./providers/kindeProvider";
import PublicApp from "./public/PublicApp";
import { isOrgLocation } from "./public/publicLocation";

// An organisation's public ranking page and the main app are two separate
// trees, chosen here before anything mounts. The main tree blocks on Kinde
// initialising and derives its auth redirect from the current origin, neither
// of which works on a district's own domain - so the public page must never
// enter it. See src/public/publicLocation.js for how the choice is made.
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <React.StrictMode>
      {isOrgLocation() ? (
        <PublicApp />
      ) : (
        <Provider store={store}>
          <KindeWrapper>
            <App />
          </KindeWrapper>
        </Provider>
      )}
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
